import React from "react";
import { motion } from "framer-motion";
const tomos = [{
  n: 1,
  title: "Los Errores que Generan Refinamientos",
  desc: "Identifica desde la primera consulta los factores que hacen que un tratamiento pierda predictibilidad y detecta los casos con mayor riesgo antes de iniciar."
}, {
  n: 2,
  title: "Planificación Clínica de Alta Predictibilidad",
  desc: "Optimiza cualquier setup antes de aprobarlo utilizando protocolos clínicos que reducen errores y aumentan la expresión real de los movimientos."
}, {
  n: 3,
  title: "El Control Total del Movimiento Dentario",
  desc: "Selecciona los attachments adecuados, controla el IPR correctamente y mejora la biomecánica de cada movimiento para obtener resultados más consistentes."
}, {
  n: 4,
  title: "Seguimiento Clínico Sin Desviaciones",
  desc: "Detecta problemas de tracking antes de que se conviertan en refinamientos y aplica protocolos de intervención durante las citas de control."
}, {
  n: 5,
  title: "Protocolos de Rescate Antes del Refinamiento",
  desc: "Recupera tratamientos que comienzan a desviarse utilizando maniobras clínicas, auxiliares y estrategias que ayudan a evitar nuevos alineadores."
}, {
  n: 6,
  title: "Cierre Inteligente y Máxima Rentabilidad",
  desc: "Finaliza tratamientos con criterios claros, evita refinamientos innecesarios de último momento y protege la rentabilidad de cada caso."
}];
export function Tomos() {
  return <section className="bg-navy-50 px-5 py-12" data-id="element-227" data-mp="3sfj5uf97kbl3">
      <div className="mx-auto max-w-md" data-id="element-228" data-mp="3sidpi4kedsdg">
        <h2 className="text-center font-display text-2xl font-extrabold text-navy-800 sm:text-3xl" data-id="element-229" data-mp="19hrnxty51v8">
          ¿Qué incluye el Sistema Antirrefinamientos?
        </h2>

        <div className="mt-6 space-y-3" data-id="element-230" data-mp="66qbe2uqtdyl">
          {tomos.map((t, i) => <motion.div key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} className="overflow-hidden rounded-2xl border border-navy-100 bg-white" data-id="element-231" data-mp="23378aib2wnvw" data-mpi={i}>
              <div className="flex items-stretch" data-id="element-232" data-mp="29xxnmta40k3s">
                <div className="flex w-16 shrink-0 flex-col items-center justify-center bg-navy-800 py-4 text-white" data-id="element-233" data-mp="29yqm76yx03au">
                  <span className="text-2xl" data-id="element-234" data-mp="24xjflb8ida5r">📘</span>
                  <span className="mt-1 text-[10px] font-bold uppercase tracking-wider text-white/60" data-id="element-235" data-mp="2ixu78ghn6srz">
                    Tomo
                  </span>
                  <span className="font-display text-xl font-extrabold text-brand-light" data-id="element-236" data-mp="2euxu35avfovf">{t.n}</span>
                </div>
                <div className="flex-1 p-4" data-id="element-237" data-mp="2npcbbdeyp9h6">
                  <h3 className="font-display text-sm font-bold leading-snug text-navy-800" data-id="element-238" data-mp="2nqn9mxpn1p0w">{t.title}</h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-navy-800/60" data-id="element-239" data-mp="32n4ldq1qp5nz">{t.desc}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}